import React, {FC} from 'react';
import CLActionModal, {CLActionModalProps} from '../../CLActionModal/CLActionModal';
import {Form, Formik, FormikConfig, FormikProps, FormikValues} from 'formik';

interface CLFormActionModal<G>
  extends Omit<CLActionModalProps, 'modalAction' | 'children'>,
    FormikConfig<G> {
  children: FC<FormikProps<G>>;
  disableWhenInvalid?: boolean;
}

function CLFormActionModal<G extends FormikValues>({
  children: renderFunc,
  initialValues,
  onSubmit,
  validationSchema,
  enableReinitialize,
  innerRef,
  isExecuting,
  validateOnMount = false,
  disableWhenInvalid = false,
  validateOnChange,
  isInitialValid,
  isOkDisabled,
  ...props
}: CLFormActionModal<G>) {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      enableReinitialize={enableReinitialize}
      innerRef={innerRef}
      validateOnMount={validateOnMount}
      validateOnChange={validateOnChange}
      isInitialValid={isInitialValid}
    >
      {({submitForm, isSubmitting, isValidating, isValid, resetForm, ...form}: FormikProps<G>) => (
        <CLActionModal
          {...props}
          onCancel={() => {
            props.onCancel?.();
            resetForm();
          }}
          isOkDisabled={
            isOkDisabled || isValidating || isSubmitting || (disableWhenInvalid && !isValid)
          }
          modalAction={onSubmit && submitForm}
          isExecuting={isExecuting || isSubmitting}
        >
          <Form>
            {renderFunc({...form, resetForm, isValid, submitForm, isValidating, isSubmitting})}
          </Form>
        </CLActionModal>
      )}
    </Formik>
  );
}

export default CLFormActionModal;
